import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Experience } from '../core/models';
import { EsperienzeListConfig, AuthService, WMAIApiService, AppInformationService, ExpLocalStorage } from '../core';
import { WgisService } from '../wgis/wgis.service';
import { WGisDisplayMode } from '../wgis/wgis.utils';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';
import { SimpleModal } from '../core/templates';

declare var $: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  isMapVisible = false;
  isSmallScreen: boolean = false;

  searchForm: FormGroup;
  destination: string;
  username: string;
  fromDate: Date;
  toDate: Date;
  type: string = 'private';

  filtersVisible = true;
  resultsVisible = true;

  bbox: string = "";

  results: Experience[] = [];
  resultsCount: number;
  loading = false;
  currentPage = 1;
  limit: number = 6;
  totalPages: Array<number> = [1];
  wait: number = 0;
  private: number = 0;
  public : number = 0;
  deleted : number = 0;
  archived : number = 0;
  shared : number = 0;
  isUserLoggedIn: boolean = false;
  savedExp: Experience[] = [];
  
  subscriptions: Subscription;

  connectionStatusMessage: string;
  connectionStatus: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private wgisservice: WgisService,
    private authservice: AuthService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private appService: AppInformationService,
    private modalService: SuiModalService,
    private explocalstorage: ExpLocalStorage
  ) { 
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    this.connectionStatus = appService.getCurrentConnectionStatus();
    this.isUserLoggedIn = this.authservice.isUserLoggedIn();
    if (this.isUserLoggedIn)
      this.username = localStorage.getItem('username');

      this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
        this.isMapVisible =  (mode !== WGisDisplayMode.Invisible);
      });

      this.wmaiservice.queryCountExperiencesPrivate(this.username).subscribe( data => {
        this.private = data[0].count;
      });
      this.wmaiservice.queryCountExperiencesDelete(this.username).subscribe( data => {
        this.deleted = data[0].count;
      });
      this.wmaiservice.queryCountExperiencesPublic(this.username).subscribe( data => {
        this.public = data[0].count;
      });
      this.wmaiservice.queryCountExperiencesWait(this.username).subscribe( data => {
        this.wait = data[0].count;
      });
      this.wmaiservice.queryCountExperiencesArchived(this.username).subscribe( data => {
        this.archived = data[0].count;
      });
      this.wmaiservice.queryCountExperiencesShared(this.username).subscribe( data => {
        this.shared = data[0].count;
      });
      this.angulartics2.eventTrack.next({ 
        action: 'search', 
        properties: {label : 'ProfileSearch' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'reset', 
        properties: {label : 'ProfileReset' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'setPageTo', 
        properties: {label : 'ProfilePagination' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'showFilters', 
        properties: {label : 'ProfileShowFilters' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'showResults', 
        properties: {label : 'ProfileShowResults' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'showMap', 
        properties: {label : 'ProfileShowMap' },
      });

      this.angulartics2.eventTrack.next({ 
        action: 'displaymap', 
        properties: {label : 'ProfileShowMap' },
      });
  }

  ngOnInit() {
    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
      if(this.connectionStatus == false){
        this.checkCacheExp();
      }
    });
    this.isMapVisible = this.wgisservice.getMapVisible();
    if(this.connectionStatus){
      if (this.isUserLoggedIn == false) this.router.navigateByUrl('/login');

      window.scrollTo(0, 0)
      this.searchForm = this.createSearchForm();
      this.search();
    } else {
      this.checkCacheExp();
    }
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

  reset() {
    this.currentPage = 1;
    this.searchForm.reset();
    this.router.navigate([], { replaceUrl: true});
  }

  search() {
    this.loading = true;
    this.currentPage = 1;
    this.totalPages = [1];
    this.getListaEsperienze();
  }

  setPageTo(pagenumber) {
    this.currentPage = pagenumber;
    this.getListaEsperienze();
  }

  showFilters() {
    this.filtersVisible = !this.filtersVisible;
    if (this.filtersVisible) {
      this.isMapVisible = false;
      this.resultsVisible = false;
    }
  }

  showMap() {
    this.isMapVisible = !this.isMapVisible;
    this.wgisservice.wgisVisible.emit( this.isMapVisible ? WGisDisplayMode.Right : WGisDisplayMode.Invisible);
    if (this.isMapVisible) {
      this.filtersVisible = false;
      this.resultsVisible = false;
    }
  }

  showResults() {
    this.resultsVisible = !this.resultsVisible;
    if (this.resultsVisible) {
      this.filtersVisible = false;
      this.isMapVisible = false;
    }
  }

  private createSearchForm() {
    return this.formBuilder.group({
      destinazione: new FormControl(this.destination, { validators: [Validators.required, Validators.maxLength(50)] }),
      type: new FormControl(this.type),
      fromDate: [''],
      toDate: ['']
    });    
  }

  private getListaEsperienze() {
    let query: EsperienzeListConfig = {
      type: 'all',
      filters: {}
    };

    query.filters.limit = this.limit;
    query.filters.pageSize = this.limit;
    query.filters.pageNumber =  this.currentPage;
    query.filters.locale = this.translateService.getDefaultLang();

    if (this.searchForm.controls["destinazione"].value != "" && this.searchForm.controls["destinazione"].value != null)
      query.filters.fulltext = this.searchForm.controls["destinazione"].value;

    if (this.searchForm.controls["type"].value != "" && this.searchForm.controls["type"].value != null)
      query.filters.type = this.searchForm.controls["type"].value;
    else
      query.filters.type = "private";
    this.results = [];
    this.wgisservice.clearSelection();

    this.loading = true;
    this.wmaiservice.queryProfileExperiences(query, this.username).subscribe(
      data => {
        if (data != null) {
          this.results.push(...data['data']);
          this.wgisservice.showExperiences(this.results);
          if (this.results != null) {
            this.resultsCount = data['metadata']['rowCount'];
            let tmp = Math.ceil(this.resultsCount / this.limit);
            this.totalPages =  this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
        }
      });
      this.loading = false;
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }

  predefSearch(search: string) {
    this.searchForm.controls["type"].patchValue(search);
    this.search();
  }

  checkCacheExp(){
    var exp = this.explocalstorage.getExperience();
    if(exp != null){
      this.getCacheExp(exp);
    } else {
      let title: string = this.translateService.instant('modal.profile.noExp.title');
      let content: string = this.translateService.instant('modal.profile.noExp.error');
      this.modalService
        .open(new SimpleModal(title, content, ModalSize.Tiny))
        .onApprove(() => "")
        .onDeny(() => "");
    }
  }

  getCacheExp(value: Experience){
    this.savedExp.push(value);
  }

}


